import { create } from "zustand"

const mockData = [
  {
    id: 495,
    name: "DE Eng",
    language: "en-US",
    numberSpeakers: 1,
    fireUrl:
      "https://ai-shopping-be.wedv.io/uploads/banner/banner-chat-1739609700.mp3",
    create_date: "2025-02-14T02:26:17.278Z",
    create_by_name: "Admin",
  },
  {
    id: 494,
    name: "Bangkok Sightseeing",
    language: "th-TH",
    numberSpeakers: 2,
    fireUrl:
      "https://ai-shopping-be.wedv.io/uploads/banner/banner-chat-1739609700.mp3",
    create_date: "2025-02-12T18:27:34.511Z",
    create_by_name: "Admin",
  },
  {
    id: 493,
    name: "NEW-TEST",
    language: "ja-JP",
    numberSpeakers: 3,
    fireUrl:
      "https://ai-shopping-be.wedv.io/uploads/banner/banner-chat-1739609700.mp3",
    create_date: "2025-02-12T18:25:57.401Z",
    create_by_name: "Admin",
  },
]

const useInterviewDialogStore = create((set, get) => ({
  interviews: mockData,

  // Add new interview
  addInterview: newInterview =>
    set(state => {
      const maxId = Math.max(...state.interviews.map(i => i.id))
      const interviewWithId = {
        ...newInterview,
        id: maxId + 1,
        create_date: new Date().toISOString(),
        create_by_name: "Admin",
      }
      return { interviews: [...state.interviews, interviewWithId] }
    }),

  // Delete interview
  deleteInterview: id =>
    set(state => ({
      interviews: state.interviews.filter(interview => interview.id !== id),
    })),

  // Get interview by ID
  getInterviewById: id => {
    const state = get()
    return (
      state.interviews.find(interview => interview.id === Number(id)) || null
    )
  },

  // Update interview
  updateInterview: updatedData =>
    set(state => ({
      interviews: state.interviews.map(interview =>
        interview.id === Number(updatedData.id)
          ? {
              ...interview,
              ...updatedData,
              create_date: interview.create_date,
              create_by_name: interview.create_by_name,
            }
          : interview
      ),
    })),
}))

export default useInterviewDialogStore
